import React, { useContext, useState } from "react";
import { Form, Grid, Label } from "semantic-ui-react";
import QuestionSet from "../components/QuestionSet";
import { BasicLoadingState } from "../State";
import { handleSubmit, store } from "../store";

const NoticeOfElectionQuestionnaire: React.FunctionComponent = () => {
    const [state, setState] = useState<BasicLoadingState>({ isLoading: false });

  const globalState = useContext(store);
  const { dispatch } = globalState;

  return (
      <Grid centered className="QuestionSetContainer">
      <Grid.Row>
              <Label size={"big"}><b>Submit Large Risk - Large Deductible, Retrospective Rating, or Large Risk Alternative Rating Option Forms Here</b></Label>
              <Label style={{ marginTop: "20px"}} size={"big"} color={"yellow"}><b>Please attach the NOE only. Do not attach the policy or any other documents.</b></Label>
      </Grid.Row>
          <Grid.Row>
              <Form size={"small"} method="post" action="/Index" encType="multipart/form-data">
                  {
                      <QuestionSet isLoading={state.isLoading} icon={state.icon}
                          onSubmit={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleSubmit({ state, setState },
                              globalState.state, e, "ENO")}
                          questionAnswers={globalState.state.answerState!} />
                  }
              </Form>
      </Grid.Row>
    </Grid>
  );
};

export default NoticeOfElectionQuestionnaire;
